import { ClientOnly } from "shared/components/ClientOnly";
import Layout from "../../components/Layout";
import { parseImagesModule } from "shared/utils/utils.js";
import React, { useEffect, useState } from "react";
// import Slider from "react-slick";

export const Page = () => {
    const [images, setImages] = useState([]);

    useEffect(() => {
        const modules = import.meta.glob('../../images/technicalSolutions/trafficAnalyzer/*.{png,jpg,jpeg,webp,avif}', {
            eager: true,
            import: 'default'
        })
        const images = parseImagesModule(modules)
        images.sort((i1, i2) => +i1.name.replace('Page', '') - +i2.name.replace('Page', ''))
        setImages(images)
    }, [])
    const renderImage = (src, i) => {
        return <picture
            style={{

            }}
            className="parameters__image">
            <source

                srcSet={src.avif}
                type="image/avif" />
            <img
                loading={i !== 0 ? 'lazy' : 'eager'}
                src={src?.jpg || src?.png}
                style={{ width: '100%' }}
                alt="слайды презентаций"
                key={i}
            />
        </picture>
    }

    const renderFallback = React.useCallback(() => {
        const defaultImg = images[0]
        if (!defaultImg) {
            return <div style={{ height: '100px' }}></div>
        }
        return renderImage(images[0], 0)
    }, [images])
    const component = React.useCallback(() => import("react-slick"))
    const settings = {
        dots: true,
        adaptiveHeight: true
    };
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    NPT Traffic Analyzer
                </h1>
                <p >
                    <b>NPT Traffic Analyzer</b> предназначен для выполнения проверки параметров локальной вычислительной сети электрической подстанции, параметров сообщений, передаваемых по сети на соответствие файлам настройки и стандарту МЭК 61850.
                </p>
                <p>
                    NPT Traffic Analyzer зарегистрирован в <a className="text-links" href="https://reestr.digital.gov.ru/reestr/2839897/" target="_blank">реестре отечественных программ Минцифры</a>.
                </p>
                <div className="mb-5 d-flex justify-content-center w-100" >
                    <div className="  w-100"
                        style={{ maxWidth: '80vw' }}>
                        <ClientOnly
                            fallback={renderFallback}
                            props={settings}
                            component={component}
                        >
                            {images.map(renderImage)}
                        </ClientOnly>
                    </div>

                </div>

                <p>Основные функции программного обеспечения:</p>

                <ul className=" ">
                    <li  >Анализ трафика на соответствие источников и приемников сигналов конфигурации, определенной файлом описания конфигурации подстанции (SCD); </li>
                    <li>Анализ и оценка временных характеристик передаваемых сигналов по протоколам стандарта МЭК 61850 внутри локальной вычислительной сети с оценкой резерва пропускной способности;</li>
                    <li>Оценка времени доставки сообщений между элементами автоматизированной системы управления технологическим процессом;</li>
                    <li>Расчет запаса производительности локальной сети исходя из максимально возможного трафика электрической подстанции.</li>
                    <li>Регистрация и хранение трафика локальной вычислительной сети;</li>
                    <li>Выдача обобщенной сигнализации в АСУ ТП при обнаружении отклонений параметров локальной вычислительной сети от заданных настроек.</li>
                </ul>
            </div>
        </div>
    </Layout>
}
